import React, { memo, useEffect } from 'react';

import FormGenerator from '@sharedCR/common/formGenerator';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { PdfSourceTypeEnum } from 'constants/loanActionEditor';
import { getConditionalArray } from 'utils/data';

import useFormContext from './hooks/useFormContext';
import { getGeneratePdfConfig } from './LoanActionsGroup.utils';

const LoanActionPdfRow = ({
  index,
  rootPath,
  isDisabled,
  isEditAllowed,
  formsOptions,
  formBundlesOptions,
  documentTypesOptions = [],
  withDocumentTypeSelection = false,
}) => {
  const {
    form,
    setForm,
    setInForm,
    setValidationErrors,
    validationErrors,
    validateField,
    handleChange,
  } = useFormContext();

  const fieldPath = `${rootPath}][${index}]`;
  const currentForm = _.get(form, fieldPath);
  const sourceTypeValue = currentForm.sourceType?.value;
  const isPreSelectSourceItem = currentForm.preSelectSourceItem;
  const isPreSelectDocumentType = currentForm.preSelectDocumentType;

  const generatePdfConfig = getGeneratePdfConfig({
    fieldPath,
    areFieldsDisabled: isDisabled || !isEditAllowed,
    isPreSelectSourceItem,
    sourceTypeValue,
    formsOptions,
    formBundlesOptions,
    withDocumentTypeSelection,
    isPreSelectDocumentType,
    documentTypesOptions,
  });

  useEffect(() => {
    const fieldsToOmit = [
      ...getConditionalArray(!isPreSelectSourceItem, [`${fieldPath}.sourceType`]),
      ...getConditionalArray(sourceTypeValue !== PdfSourceTypeEnum.FORM, [`${fieldPath}.form`]),
      ...getConditionalArray(sourceTypeValue !== PdfSourceTypeEnum.FORM_BUNDLE, [
        `${fieldPath}.formBundle`,
      ]),
      ...getConditionalArray(!withDocumentTypeSelection || !isPreSelectDocumentType, [
        `${fieldPath}.documentType`,
      ]),
    ];

    setForm(prev => _.omit(prev, fieldsToOmit));
    setValidationErrors(prev => _.omit(prev, fieldsToOmit));
  }, [
    isPreSelectSourceItem,
    sourceTypeValue,
    withDocumentTypeSelection,
    isPreSelectDocumentType,
    fieldPath,
    setForm,
    setValidationErrors,
  ]);

  return (
    <FormGenerator
      isNestedForm
      config={generatePdfConfig}
      form={form}
      handleChange={handleChange}
      setInForm={setInForm}
      validateField={validateField}
      validationErrors={validationErrors}
    />
  );
};

LoanActionPdfRow.propTypes = {
  rootPath: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  formsOptions: PropTypes.array.isRequired,
  formBundlesOptions: PropTypes.array.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  isEditAllowed: PropTypes.bool.isRequired,
  documentTypesOptions: PropTypes.array,
  withDocumentTypeSelection: PropTypes.bool,
};

export default memo(LoanActionPdfRow);
